// /app/frontend/src/components/configurator/SaveConfigDialog.jsx
// Dialog for saving shade configuration as a preset

import React from 'react';
import { Bookmark, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';

const SaveConfigDialog = ({
  open,
  onOpenChange,
  configName,
  setConfigName,
  onSave,
  saving,
  config,
  selectedFabricMaterial,
  selectedCollection,
  selectedColor
}) => {
  // Build fabric name with fallbacks
  const fabricName = selectedFabricMaterial?.name 
    || selectedCollection?.name 
    || selectedColor?.name 
    || 'No fabric selected';
    
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Bookmark className="w-5 h-5 text-amber-600" />
            Save Configuration
          </DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-neutral-500 mb-4">
            Save your current shade configuration as a preset for quick access later.
          </p>
          <Label>Configuration Name</Label>
          <Input
            value={configName}
            onChange={(e) => setConfigName(e.target.value)}
            placeholder="e.g., Living Room Shades"
            className="mt-2"
            autoFocus
          />
          <div className="mt-4 p-3 bg-neutral-50 rounded-lg text-sm">
            <p className="font-medium text-neutral-700 mb-1">Current Configuration:</p>
            <p className="text-neutral-500">
              {config.width}" × {config.height}" • {fabricName} • {config.mount_type} mount
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={onSave}
            disabled={saving || !configName.trim()}
            className="bg-amber-600 hover:bg-amber-700"
          >
            {saving ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Saving...
              </>
            ) : (
              <>
                <Bookmark className="w-4 h-4 mr-2" />
                Save Preset
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SaveConfigDialog;
